import { useState, useEffect, useRef } from "react";
import { getChatGpt } from "@/api/apiMethods.js";
import aya from '@/assets/ai/ayalogo.png';
import ayamp4 from '@/assets/ai/ayalogo.mp4';
import ayaborder from '@/assets/ai/ayaborder.png';
import ayabg from '@/assets/ai/ayabg.png';
import ayadial from '@/assets/ai/ayadial.png';
import ayainput from '@/assets/ai/ayainput.png';
import ayabutton from '@/assets/ai/ayabutton.png';
import appayabtn from '@/assets/ai/appayabtn.png';
import appclose from '@/assets/ai/appclose.png';
import './Chatgpt.css';

// eslint-disable-next-line react/prop-types
function ChatgptComponent({ greetingMessage }) {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [conversatioId, setConversatioId] = useState("");
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isTextAreaActive, setIsTextAreaActive] = useState(false);
    const lastMessageRef = useRef(null);
    const timeoutRef = useRef(null); // Store timeout reference

    const messageContainerRef = useRef(null);  // 用来引用消息容器

    useEffect(() => {
        const randomUserId = Math.floor(Math.random() * 10000) + 1;
        setUserId(randomUserId);
    }, []);

    useEffect(() => {
        setMessages([{ text: "...", sender: "gpt", loading: true }]);
    }, []);

    useEffect(() => {
        if (greetingMessage && greetingMessage !== messages[0]?.text) {
            let charIndex = 0;
            const typingSpeed = 15;
            const typingEffect = () => {
                if (charIndex < greetingMessage.length) {
                    setIsTextAreaActive(true);
                    setIsOpen(true)
                    setMessages(prevMessages => [
                        { text: greetingMessage.substring(0, charIndex + 1), sender: "gpt", loading: false }
                    ]);
                    charIndex++;
                } else {
                    clearInterval(typingInterval);
                    // Clear any previous timeout before setting a new one
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(() => {
                        setIsTextAreaActive(false);
                        setIsOpen(false)
                    }, 5000);
                }
            };

            const typingInterval = setInterval(typingEffect, typingSpeed);

            return () => {
                clearInterval(typingInterval);
                // Cleanup timeout when component unmounts or changes
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            };
        }
    }, [greetingMessage]);

    useEffect(() => {
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }
    }, [messages]);

    const sendMessage = async () => {
        if (!input.trim()) return;
        setMessages([{ text: "...", sender: "gpt", loading: true }]);
        if (userId === null) return;

        setLoading(true);
        try {
            const response = await getChatGpt({
                user_id: String(userId),
                message: input,
                conversation_id: conversatioId,
            });

            updateMessagesWithReply(response.reply.answer);
            setConversatioId(response.reply.conversation_id);
        } catch (error) {
            console.error("Error fetching GPT response:", error);
            setMessages([{ text: "Sorry, something went wrong. Please try again.", sender: "gpt" }]);
        } finally {
            setLoading(false);
        }
    };

    const updateMessagesWithReply = (reply) => {
        setMessages(prevMessages =>
            prevMessages.map(msg => (msg.loading ? { ...msg, text: "", loading: false } : msg))
        );

        let charIndex = 0;
        const typingSpeed = 15;

        const typeMessage = () => {
            setIsTextAreaActive(true);
            if (charIndex < reply.length) {
                setMessages(prevMessages => [
                    ...prevMessages.slice(0, prevMessages.length - 1),
                    { text: reply.substring(0, charIndex + 1), sender: "gpt", loading: false }
                ]);
                charIndex++;
            } else {
                clearInterval(typingInterval);
                // Clear any previous timeout before setting a new one
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = setTimeout(() => {
                    setIsTextAreaActive(false);
                }, 5000);
            }
        };

        const typingInterval = setInterval(typeMessage, typingSpeed);
    };

    const filteredMessages = messages.filter(message => message.sender === "gpt");

    return (
        <div>
            {/* web */}
            <div className='sm:block hidden'>
                <div className={`fixed top-1/2 right-[145px] transform -translate-y-1/2 z-[999] text-white transition-opacity duration-300 ${isTextAreaActive ? 'opacity-100' : 'opacity-50'}`}>
                    <div className="relative">
                        <div className="relative z-10">
                            {isTextAreaActive ? (
                                <>
                                    <img src={ayaborder} alt="" className="w-[320px] h-[443px] absolute bottom-8 right-4" />
                                    <video className="w-[330px] h-[450px]" loop autoPlay muted>
                                        <source src={ayamp4} type="video/mp4" />
                                    </video>
                                </>
                            ) : (
                                <img src={aya} alt="" className="w-[300px] h-[400px]" />
                            )}
                        </div>
                        <div className={` absolute z-10 ${isTextAreaActive ? 'top-0' : 'top-[-25px]'} right-[-115px] w-[212px] h-[168px]`}>
                            <img src={ayadial} alt="" className="w-[212px] h-[168px]" />
                            <div className="absolute top-[20px] left-0 w-full h-full flex flex-col" >
                                {filteredMessages.map((message, index) => (
                                    <div key={index} className="flex justify-start">
                                        <div className="flex items-start">
                                            <div className="ml-2">
                                                <div className="inline-block w-[185px] h-[121px] overflow-scroll p-2 m-1 rounded-lg text-sm font-silkscreen bg-[#060732]" ref={messageContainerRef}>
                                                    {message.loading ? (
                                                        <span className="text-gray-400 animate-pulse font-bold text-3xl">...</span>
                                                    ) : (
                                                        message.text
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div ref={lastMessageRef}></div>
                            </div>
                        </div>

                        <div className="absolute z-10 bottom-[-20px] left-[-50px] w-[443px] h-[146px]">
                            <img src={ayainput} alt="" className="w-full h-full" />
                            <textarea
                                className="absolute top-1/2 left-[170px] transform -translate-x-1/2 -translate-y-1/2 w-[250px] h-[70px] p-2 rounded bg-[#01010f] z-20 resize-none border-none outline-none font-silkscreen"
                                value={input}
                                onChange={(e) => {
                                    setInput(e.target.value)
                                }}
                                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                                onFocus={() => setIsTextAreaActive(true)}  // Textarea gets focused
                                onBlur={() => {
                                    if (timeoutRef.current) {
                                        clearTimeout(timeoutRef.current);  // Clear previous timeout
                                    }
                                    timeoutRef.current = setTimeout(() => {
                                        setIsTextAreaActive(false);
                                    }, 5000);  // Set new timeout
                                }}
                                placeholder="Type your message..."
                                rows="4"
                                cols="30"
                            ></textarea>
                            <div className="w-[82.5px] h-[47.5px] absolute top-[50px] right-[45px] z-20 cursor-pointer transform transition duration-150 ease-in-out active:scale-95" onClick={sendMessage} disabled={loading}>
                                <img src={ayabutton} alt="" className="w-full h-full" />
                                <span className="absolute top-0 left-0 w-full h-full flex justify-center items-center text-white z-30 font-silkscreen">
                                    {loading ? 'Sending' : 'Send'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* app */}
            <div className="sm:hidden block">
                {!isOpen && (
                    <div
                        className="fixed bottom-5 right-5 rounded cursor-pointer shadow-lg w-[3.25rem] h-[3.25rem] border-2  border-white flex items-center justify-center"
                        onClick={() => setIsOpen(true)}
                    >
                        <img src={appayabtn} alt="" className="w-8 h-11" />
                    </div>
                )}

                {isOpen && (
                    <div
                        className="fixed bottom-[10vh] right-[20vw] z-[999]"
                        style={{ width: '80vw' }}
                    >
                        <img src={ayaborder} alt="" className="w-[300px] h-[443px] absolute bottom-8 right-4" />
                        <video className="w-[264px] h-[450px] ml-8" loop autoPlay muted playsInline
                            // eslint-disable-next-line react/no-unknown-property
                            webkit-playsinline="true">
                            <source src={ayamp4} type="video/mp4" />
                        </video>
                        <div className="absolute z-10 top-[2vw] right-[-18.5vw] h-[20%] w-[160px]">
                            <img src={ayadial} alt="" className="w-[212px] h-[168px]" />
                            <div className="absolute top-[20px] left-0 w-full h-full flex flex-col" >
                                {filteredMessages.map((message, index) => (
                                    <div key={index} className="flex justify-start">
                                        <div className="flex items-start">
                                            <div className="ml-2">
                                                <div className="text-white inline-block w-[139px] h-[121px] overflow-scroll p-2 m-1 rounded-lg text-sm font-silkscreen bg-[#060732]" ref={messageContainerRef}>
                                                    {message.loading ? (
                                                        <span className="text-gray-400 animate-pulse font-bold text-3xl">...</span>
                                                    ) : (
                                                        message.text
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div ref={lastMessageRef}></div>
                            </div>
                        </div>
                        <div className="absolute z-10 bottom-[-2vw] left-0 h-[20%]">
                            <img src={ayainput} alt="" className="w-[200vw]" />
                            <textarea
                                className="text-base absolute top-[13vw] left-[120px] transform -translate-x-1/2 -translate-y-1/2 w-[45vw] h-[55px] p-2 rounded bg-[#01010e] z-20 resize-none border-none outline-none font-silkscreen"
                                value={input}
                                onChange={(e) => {
                                    setInput(e.target.value)
                                }}
                                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                                onFocus={() => setIsTextAreaActive(true)}  // Textarea gets focused
                                onBlur={() => {
                                    if (timeoutRef.current) {
                                        clearTimeout(timeoutRef.current);  // Clear previous timeout
                                    }
                                    timeoutRef.current = setTimeout(() => {
                                        setIsTextAreaActive(false);
                                    }, 5000);  // Set new timeout
                                }}
                                placeholder="Type your message..."
                                rows="4"
                                cols="30"
                            ></textarea>
                            <div className="w-[62.42px] h-[35px] absolute top-[35px] right-[20px] z-20 cursor-pointer transform transition duration-150 ease-in-out active:scale-95" onClick={sendMessage} disabled={loading}>
                                <img src={ayabutton} alt="" className="w-full h-full" />
                                <span className="absolute top-0 left-0 w-full h-full flex justify-center items-center text-white z-30 font-silkscreen">
                                    {loading ? 'Sending' : 'Send'}
                                </span>
                            </div>
                        </div>
                        <div
                            className="absolute top-[79%] right-[-5%] bg-black text-white w-6 h-6 rounded-full text-sm flex items-center justify-center"
                            onClick={() => setIsOpen(false)}
                        >
                            <img src={appclose} alt="" />
                        </div>
                    </div>

                )}
            </div>
        </div>
    );
}

export default ChatgptComponent;
